import React, { useState,useEffect } from "react";
import Grid from "@mui/system/Grid";
import UpsertPaymentMethod from "./payments/UpsertPaymentMethod";
import { getPaymentMethod } from "../../_api/paymentApi";
import PropTypes from "prop-types";

const Confirm = ({ccToken,appointmentData,handleUpdate}) => {
  const editItems = null;
  const enrolleeUser = JSON.parse(sessionStorage.getItem("enrolleeUser"));

  const [paymentMethod, setPaymentMethod] = useState([]);

    useEffect(() => {
    if (enrolleeUser) {
      getPaymentMethod(enrolleeUser?.clientId || enrolleeUser?.ClientId)
        .then((x) => {
          setPaymentMethod(x);
        })
        .catch((e) => {
          console.log("error", e);
        });
    }
  }, []);

  return (
    <>
      <Grid
        style={{
          width: "100%",
          // background:"red",
          // marginBottom: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // maxWidth: "900px",
        }}
      >
        <UpsertPaymentMethod
          user={enrolleeUser}
          items={editItems}
          paymentMethod={paymentMethod}
          // setActiveStep={setActiveStep}
          ccToken={ccToken}
          appointmentData={appointmentData}
          handleUpdate={handleUpdate}
          // editCancel={onEditCancel}
        />
      </Grid>
    </>
  );
};

Confirm.propTypes = {
  setActiveStep:PropTypes.func,
  ccToken:PropTypes.string,
  appointmentData: PropTypes.object,
  handleUpdate: PropTypes.func,
};

export default Confirm;
